import { SVGProps } from 'react';

const Gem = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 3 8 9l4 13m0 0 4-13-2.5-6M12 22a2 2 0 0 0 1.623-.832l7.99-10.986A2 2 0 0 0 21.6 7.8l-3-4A2 2 0 0 0 17 3H7a2 2 0 0 0-1.602.803L2.4 7.8a2 2 0 0 0-.014 2.382l7.99 10.986A2 2 0 0 0 12 22M2 9h20"
    />
  </svg>
);
export default Gem;
